export const NotificationTypes = [
  'ActivityApprovedNotification', // 공고 승인 알림
  'ActivityRefusedNotification', // 공고 반려 알림
  'NewActivityNotification', // 새로운 공고 알림
  'BookmarkToNewsItemNotification', // 소식 스크랩 알림
  'CommentToCommentNotification', // 내가 작성한 커뮤니티 게시글 댓글의 답글 알림
  'CommentToPostNotification', // 내가 작성한 커뮤니티 게시글의 댓글 알림
  'FollowToChannelNotification', // 내 채널 팔로우 알림
  'LikeToNewsItemNotification', // 내가 작성한 소식의 좋아요 알림
  'NewsCommentToNewsCommentNotification', // 내가 작성한 소식 댓글의 답글 알림
  'NewsCommentToNewsItemNotification', // 내가 작성한 소식의 댓글 알림
  'NewNewsItemNotification', // 새로운 소식 알림
  'OrganizationApprovedNotification', // 기업 정보 승인 알림
  'OrganizationPendingNotification', // 기업 정보 승인 대기중 알림
  'ReplyToActivityNotification', // 내가 작성한 공고의 댓글 알림
  'ReplyToReplyNotification', // 내가 작성한 공고 댓글의 답글 알림
  'ScrapActivityCloseSoonNotification', // 내가 스크랩한 공고 마감 3일전 알림
  'ScrapActivityCloseSoonerNotification', // 내가 스크랩한 공고 마감 1일전 알림
  'ChatMessageReplyNotification', // 내가 작성한 채팅방 댓글의 답글 알림
  'AcceptedMentorCommentRewardNotification', // 멘토 댓글 채택 보상 알림
  'CommentToMentorPostNotification', // 내가 작성한 멘토 게시글의 댓글 알림
  'RecommendedMentorPostNotification', // 추천 멘토 게시글 알림
  'MatchedMentorCommentRewardNotification', // 멘토 댓글 채택 보상 알림
  'MentorApprovedNotification', // 멘토권한 승인 알림
] as const

export type NotificationType = (typeof NotificationTypes)[number]

export type handleClickNotificationType = (id: string) => void
export type handleClickDeleteNotificationType = (id: string) => void
